<template>
  <div class="base-datepicker">
    <date-picker
      ref="dRef"
      :lang="lang"
      :value="date"
      :confirm="false"
      :placeholder="placeholder"
      confirm-text="Apply"
      :disabled-date="disabledDate"
      :disabled-time="notBeforeTime"
      :default-value="defaultValue"
      @change="onChange"
      :open.sync="open"
      :type="datepickerType"
      :disabled="disabled"
      :editable="false"
      popup-class="base-datepicker"
      time-title-format="YYYY-MMMM-DD"
      :show-time-header="false"
      :clearable="false"
      range-separator=" - "
      :format="datepickerFormat"
      :range="range">
      <template v-slot:footer="{ emit, value }">
        <div class="base-datepicker-footer">
          <span class="base-current-date">{{formatDate(value)}}</span>
          <button @click="open=false" class="base-cancel-button btn btn-custom btn-sm">Cancel</button>
        </div>
      </template>
      <template v-slot:input="{props}">
        <b-input
          :value="props.value"
          :type="props.type"
          :readonly="props.readonly"
          :disabled="props.disabled"
          :placeholder="props.placeholder"
          :label="label"
          :input-class="`calendar-${type}`"
          :clearable="true"
          @on-clear="onClear"
          custom-icon-class="fak fa-angle-down-regular"
        />
      </template>
      <template v-slot:icon-calendar>
        <i :class="['fak fa-calendar-lines-pen-light', type && `calendar-${type}`, date && 'date-filled', disabled && 'date-disabled']" />
      </template>
    </date-picker>
  </div>
</template>
<script>
import Vue from 'vue'
import DatePicker from "vue2-datepicker";
import BInput from "@/components/__new_ui_kit/Input/BInput";
export default Vue.extend({
  props: {
    date: {},
    range: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Select date'
    },
    label: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // primary / secondary
    type: {
      type: String,
      default: 'primary'
    },
    datepickerType: {
      type: String,
      default: 'datetime'
    },
    datepickerFormat: {
      type: String,
      default: 'YYYY-MM-DD HH:mm'
    },
    disabledBefore: {
      default: new Date()
    },
    defaultValue: {
      default: new Date()
    }
  },
  data() {
    return {
      open: false,
      showTimePanel: false,
      lang: {
        monthFormat: 'MMMM'
      },
    }
  },
  components: {
    BInput,
    DatePicker
  },
  computed: {
    needClearIcon() {
      return !!this.date
    }
  },
  methods: {
    notBeforeTime(date) {
      if (this.$moment(date).format('YYYY-MM-DD') === this.$moment(this.disabledBefore).add(1, 'days').format('YYYY-MM-DD')) {
        if (date.getHours() === new Date(this.disabledBefore).getHours()) {
          return (date.getMinutes() < new Date(this.disabledBefore).getMinutes())
        }
        return date.getHours() < new Date(this.disabledBefore).getHours();
      }
    },
    onChange(value) {
      this.$emit('on-change', value)
    },
    disabledDate(date) {
      if (!!this.disabledBefore) {
        return new Date(date) <= this.disabledBefore
      }
      return false
    },
    onClear() {
      if (!this.disabled) {
        this.$emit('on-change', null)
      }
    },
    formatDate(value) {
      if (Array.isArray(value)) {
        const [from, to] = value
        let fFrom = this.$moment(from).format('MM/DD/YYYY')
        let fTo = this.$moment(to).format('MM/DD/YYYY')
        if (fFrom === 'Invalid date') fFrom = '...'
        if (fTo === 'Invalid date') fTo = '...'
        return `${fFrom} - ${fTo}`
      } else {
        let fDate = this.$moment(value).format('MM/DD/YYYY')
        if (fDate === 'Invalid date') return '...'
        return fDate
      }
    }
  },
  watch: {
  }
})
</script>
<style lang="scss">;
.base-datepicker {
  border-radius: 4px;
  &.mx-datepicker-popup {
    box-shadow: 4px 4px 8px rgba(0,0,0,.15);
  }
  &.mx-zoom-in-down-enter-active, &.mx-zoom-in-down-leave-active {
    transition: all .3s;
  }
  &.mx-zoom-in-down-enter,
  &.mx-zoom-in-down-enter-from,
  &.mx-zoom-in-down-leave-to {
    opacity: 0;
    transform: translateY(15px);
  }
  div, th, button {
    @include p-source-sans();
    color: $color-secondary-text;
  }
  .mx-table-date thead th {
    color: $color-main-text
  }
  .mx-datepicker, .mx-datepicker-range {
    width: 100%;
    min-width: 240px;
  }
  .cell > div {
    width: 36px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cell.active > div {
    color: white;
  }

  .mx-icon-calendar {
    left: 12px;
    top: unset;
    bottom: 4px;
    cursor: pointer;
    pointer-events: none;
    color: $color-secondary-text;
    .date-filled, .calendar-secondary {
      color: $color-main-text;
    }
    .date-disabled {
      color: $color-secondary-text;
    }
  }
  .mx-input-wrapper {
    .input-control input{
      padding-left: 34px;
      &:disabled {
        & ~ i {
          color: $color-secondary-text;
        }
      }
    }
    .input-control .calendar-secondary {
      background-color: #f8f8f8;
      &::placeholder {
        color: $color-main-text;
      }
    }
  }
  .mx-datepicker-content {
    .cell {
      &.in-range {
        background-color: #E1F0FF;
      }
      &.active {
        background-color: #2889F0;
        border-radius: 4px;
      }
    }
    .mx-range-wrapper {
      .cell {
        &.active {
          border-radius: 4px 0 0 4px;
        }
      }
      .cell.in-range ~ .cell.active {
        border-radius: 0 4px 4px 0;
      }
    }
    .mx-datepicker-body {
      .mx-calendar {
        width: 297px;
        padding: 20px;
        border-left: none;
        &-header {
          margin-bottom: 20px;
          .mx-calendar-header-label {
            pointer-events: none;
            margin-top: 6px;
            display: block;
            button {
              color: $color-main-text;
            }
          }
          .mx-icon-double-left, .mx-icon-double-right {
            display: none;
          }
          .mx-btn-icon-left,.mx-btn-icon-right {
            transition: 0.2s ease-in;
            padding: 3px 12px;
            min-height: 28px;
            background: #f8f8f8;
            border: 1px solid #d2d6de;
            color: $color-main-text;
            &:hover {
              color: $color-main-text;
              background: #f8f9fa;
              border-color: #c5c7ca;
            }
            .mx-icon-left {
              &:before {
                left: 1px;
              }
            }
            .mx-icon-right {
              &:before {
                right: 1px;
              }
            }
          }
        }
        &-content {
        }
      }
    }
    .mx-datepicker-footer {
      position: relative;
      padding: 12px;
      min-height: 52px;
      display: flex;
      justify-content: flex-end;
      .base-datepicker-footer {
        display: flex;
        gap: 16px;
        align-items: center;
        position: absolute;
        right: 10px;
        .base-current-date {
          display: none;
        }
      }
      .base-current-date {
        color: $color-main-text;
        font-size: 12px;
      }
      .base-cancel-button {
        color: $color-main-text;
        width: 64px;
      }
      .mx-datepicker-btn-confirm {
        width: 58px;
        padding: 3px 12px;
        min-height: 28px;
        color: #fff;
        background-color: #007bff;
        border-color: #0173ee;
        &:hover {
          background-color: #0173ee;
          border-color: #0173ee;
        }
      }
    }
  }
}
</style>
